import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import useTheme from './similar-contributors-components/theme';
import { listTypes } from './similar-contributors-components/prop-types';
import ListView from './similar-contributors-components/list-view';
import GridView from './similar-contributors-components/grid-view';

const Container = styled.div`
  margin-top: 48px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.header`
  width: 100%;
  font: ${props => props.theme.fontWeightDccc} 18px/20px ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
  text-transform: uppercase;
  border-bottom: 1px solid ${props => props.theme.primaryColor};
  padding-bottom: 8px;
`;

const type2view = {
  list: ListView,
  circle: GridView,
  square: GridView,
};

export default function SimilarContributors({ type, list }) {
  const View = React.useMemo(() => type2view[type], [type]);

  return (
    <ThemeProvider theme={useTheme()}>
      <Container>
        <Header>similar contributors</Header>
        <View list={list} type={type} />
      </Container>
    </ThemeProvider>
  );
}

SimilarContributors.propTypes = {
  type: PropTypes.oneOf(['list', 'square', 'circle']).isRequired,
  list: listTypes.isRequired,
};
